import { AbstractKeyEncapsulationMechanism } from '../interface';
import { ml_kem1024 } from '@noble/post-quantum/ml-kem.js';

export class MLKEM1024KEM extends AbstractKeyEncapsulationMechanism {
  public static create(public_key: Uint8Array): {
    cipherText: Uint8Array;
    sharedSecret: Uint8Array;
  } {
    return ml_kem1024.encapsulate(public_key);
  }

  public static unpack(secret_key: Uint8Array, ciphertext: Uint8Array): Uint8Array {
    return ml_kem1024.decapsulate(ciphertext, secret_key);
  }

  public static describe(): string {
    return 'MLKEM1024-KEM';
  }
}
